import React from 'react'
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab'
import styled from 'styled-components'

import { Presets } from './const'

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  button {
    border: 1px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};

    &.Mui-selected,
    &.Mui-selected:hover,
    &:hover {
      background-color: ${props => props.theme.colors.primary};
      color: #fff;
    }
  }
`

const PresetToggle = ({ preset, onChange }) => {
  const onChangePreset = (e, newPreset) => {
    if (newPreset !== null) {
      onChange(newPreset)
    }
  }

  return (
    <StyledToggleButtonGroup
      value={preset}
      exclusive
      onChange={onChangePreset}
      aria-label=""
      size="small"
    >
      <ToggleButton value={0} aria-label="">
        {Presets[0]}
      </ToggleButton>
      <ToggleButton value={1} aria-label="">
        {Presets[1]}
      </ToggleButton>
      <ToggleButton value={2} aria-label="">
        {Presets[2]}
      </ToggleButton>
    </StyledToggleButtonGroup>
  )
}

export default PresetToggle
